import { createFileRoute, useLocation } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import { useEffect, useState } from "react";

import { RecordDetails } from "@/components/record-details";
import { useRecordDetailsPanel } from "@/pages/home/components/RecordDetailsPanelContext";
import { AgentPerformanceDashboardSearchSchema } from "@/pages/home/components/agent-performance-dashboard/agent-performance-dashboard-search.schema";
import { useDashboardRole } from "@/pages/home/components/role-dashboard/hooks/useDashboardRole";
import { RoleDashboard } from "@/pages/home/components/role-dashboard/role-dashboard";
import { hasRoleHomeDashboard } from "@/pages/home/components/role-dashboard/utils/resolve-dashboard-role";
import { useCall } from "@/providers/hooks/use-call";
import { APP_ROUTES_FULL } from "@/utils/routes";

import { Dashboard } from "./home/components/dashboard";

export const Route = createFileRoute(APP_ROUTES_FULL.ROOT)({
    component: Home,
    validateSearch: zodValidator(AgentPerformanceDashboardSearchSchema),
    staticData: {
        config: {
            title: "home",
        },
    },
});

function Home() {
    const { isCallActive, currentCallData } = useCall();
    const [isRecordDetailsVisible, setIsRecordDetailsVisible] = useState(false);
    const location = useLocation();
    const { role } = useDashboardRole();
    const showRoleDashboard = hasRoleHomeDashboard(role);

    const recordPanel = useRecordDetailsPanel();

    const callIsActive = isCallActive();

    useEffect(() => {
        if (callIsActive) {
            setIsRecordDetailsVisible(true);
        } else {
            setIsRecordDetailsVisible(false);
        }
    }, [callIsActive]);

    useEffect(() => {
        const state = location.state as { showRecordDetails?: boolean; showCallDetails?: boolean };
        if ((state?.showRecordDetails || state?.showCallDetails) && callIsActive) {
            setIsRecordDetailsVisible(true);
        }
    }, [location.state, callIsActive]);

    if (!recordPanel) return null;
    const { show, recordId, moduleType } = recordPanel;

    return (
        <div className="relative flex h-full min-h-0 flex-col">
            <div className="min-h-0 flex-1 overflow-hidden">
                {(show && recordId) || (callIsActive && isRecordDetailsVisible) ? (
                    <RecordDetails
                        recordId={
                            callIsActive && isRecordDetailsVisible ? currentCallData?.recordId : (recordId ?? undefined)
                        }
                        moduleType={callIsActive && isRecordDetailsVisible ? currentCallData?.moduleType : moduleType}
                    />
                ) : showRoleDashboard ? (
                    <RoleDashboard role={role} />
                ) : (
                    <Dashboard />
                )}
            </div>
        </div>
    );
}
